import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { IMG } from "@/data/site";

const menu = [
  ["Beach BBQ & Grill", "Fresh catch, mishkaki skewers and grilled favourites off the coals."],
  ["Signature Cocktails", "The Zuri Sunset, Dawa Royale and coastal-spiced classics."],
  ["Fresh Island Juices", "Tropical juices, smoothies and mocktails all day."],
  ["Tanzanian Craft", "Local beers, Konyagi serves and fine spirits."],
];

export default function BarLounge() {
  return (
    <div data-testid="bar-lounge-page">
      <PageHero overline="Dining" title="Baobab Bar" subtitle="Beach BBQ & grill, cold pours and ocean air — from morning till late." image={IMG.baobabBar} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">Open Daily · 10:00 – 23:00</p>
            <h2 className="font-serif-display text-4xl font-light text-white leading-tight">Where days begin — and evenings linger</h2>
            <p className="mt-6 text-[#a3a3a3] leading-relaxed max-w-lg">
              Under the shade of the ancient baobab, our beach bar serves fresh juices, signature cocktails and BBQ &amp; grill favourites from 10 in the morning until 11 at night — toes in the sand, ocean in view.
            </p>
            <div className="mt-10 space-y-6">
              {menu.map(([t, d]) => (
                <div key={t} className="border-l-2 border-[#d4af37]/50 pl-5">
                  <h3 className="font-serif-display text-xl text-white">{t}</h3>
                  <p className="text-sm text-[#a3a3a3] mt-1">{d}</p>
                </div>
              ))}
            </div>
          </FadeUp>
          <Stagger className="grid grid-cols-2 gap-4">
            <StaggerItem className="img-zoom aspect-[3/4]"><img src={IMG.baobabBar} alt="Baobab Bar" className="w-full h-full object-cover" /></StaggerItem>
            <StaggerItem className="img-zoom aspect-[3/4] mt-10"><img src={IMG.wineTable} alt="Garden wine and fruit" className="w-full h-full object-cover" /></StaggerItem>
          </Stagger>
        </div>
      </section>
    </div>
  );
}
